import { css } from "@emotion/css";
import colors from "src/utils/colors";

const MenuTitle = (props) => (
  <h2
    {...props}
    className={css`
      font-size: 0.9rem;
      padding: 1rem;
      margin: 0;
      font-weight: normal;
    `}
  />
);

const MenuButtonContainer = (props) => (
  <div
    {...props}
    className={css`
      padding: 1rem 1rem 0 1rem;
      & button {
        width: 100%;
      }
    `}
  />
);

const MenuItemContainer = (props) => (
  <div
    {...props}
    className={css`
      border-bottom: 1px solid ${colors.borderGray};
      margin: 0 0 1rem 0;
    `}
  />
);

export { MenuButtonContainer, MenuItemContainer, MenuTitle };
